const defaultFlags = {
    education: false,
    'mandatory-email-verification': false,
    'hubspot-chat-support': false,
    'workspace-members-filter': false,
    'report-subscriptions-to-sentry': false,
    'public-api-manage-personal-tokens': false,
    'cwv-custom-grid': false,
    'restricted-uploads': false,
    'design-systems': false,
    'design-systems-editor': false,
    'components-description': false,
    'component-ingest-on-demand': false,
    'guests-in-project': false,
    profiles: false,
    'profile-document-detail-view': false,
    'community-canvas': false,
    'publish-community': false,
    'dark-mode-toggle': false,
    'scim-access': false,
    'frontend-consolidate': false,
    'pages-unread-annotations': false,
    sidebar: false,
    'collections-select-all-documents': false,
    /**
     * Escape hatch allowing to not request Customer.billing
     * https://github.com/sketch-hq/Cloud/issues/16798
     */
    'workspaces-dropdown-trial-pill': false,
    // these flags are used when user is not even signed in
    // it is expected that these flags will be changed
    // using DevTools
    'new-sharing': false,
    'annotations-summary': false,
    'publication-hearts': false,
    'search-filter-sort': false,
    'troubleshooting-consent': false,
    'web-renderer-marina-inspector': false,
    'export-design-tokens': false,
    'partner-and-resellers-support': false,
    'embedded-discover': false,
    'updates-page-revamp': false,
    'archive-projects-documents': false,
    pinning: false,
};

export { defaultFlags };
